
export default {
  name: 'EmptyComponent'
}
